import {DecimalPipe} from '@angular/common'
import {Component, inject} from '@angular/core'
import {
  MatExpansionPanel,
  MatExpansionPanelContent,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion'
import {MatTab, MatTabContent, MatTabGroup} from '@angular/material/tabs'
import {AdminService} from '../../services/admin.service'
import {TableComponent} from './table/table.component'
import {IStatsArrayKey} from '../../services/types'


@Component({
  selector: 'spb-statistics',
  templateUrl: './statistics.component.html',
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatTabGroup,
    MatTab,
    MatTabContent,
    TableComponent,
    DecimalPipe,
    MatExpansionPanelContent
  ]
})
export class StatisticsComponent {
  public readonly adminService = inject(AdminService)

  public readonly tabArray = [
    {title: 'Vecka', data: 'weeks' as IStatsArrayKey, range: 'week'},
    {title: 'Månad', data: 'months' as IStatsArrayKey, range: 'month'},
    {title: 'År', data: 'years' as IStatsArrayKey, range: 'year'},
    {title: 'Veckodag', data: 'weekdays' as IStatsArrayKey, range: 'weekday'},
    {title: 'Dag (i månad)', data: 'days' as IStatsArrayKey, range: 'day'},
    {title: 'Alla', data: 'all' as IStatsArrayKey, range: 'all'},
    {title: 'Ålder (sökande)', data: 'ages' as IStatsArrayKey, range: 'age'},
    {title: 'Kön (enl. pers.nr.)', data: 'sexes' as IStatsArrayKey, range: 'sex'},
    {title: 'Risk (sökande)', data: 'risks' as IStatsArrayKey, range: 'risk'}
  ]
}